import Util from '../util.js';

export const webViewHtmlString = (text)=>{
	return {
		type: 'WEB_VIEW_HTML',
		text
	}
}

// export const webViewUrl = (text)=>{
// 	return {
// 		type: 'WEB_VIEW_URL',
// 		text
// 	}
// }

export const getWebViewHtml = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = (suc)=>{
			console.log(suc);
			if(suc.code == params.code){
				dispatch(webViewHtmlString(suc.content));
				// succallback();
			}else{
				console.log('后台返回html数据有误！');
				// errcallback(suc.message);
				dispatch(webViewHtmlString(''));
			}
		};
		const errorCallback = (err)=>{
			console.log('请求html字符串失败！');
			// errcallback(Util.errorTxt);
			// dispatch(webViewHtmlString(''));
		};
		Util.get(Util.url + '/api/cms/getProtocolByCode', params, successCallback, errorCallback);
	}
}

// export const getWebViewUrl = (params, succallback, errcallback)=>{
// 	return (dispatch, getState)=>{
// 		const successCallback = (suc)=>{
// 			if(suc.code == '0000'){
// 				dispatch(webViewUrl(suc.content));
// 				succallback();
// 			}else{
// 				console.log('后台返回URL数据有误！');
// 				errcallback(suc.message);
// 				dispatch(webViewUrl(''));
// 			}
// 		};
// 		const errorCallback = (err)=>{
// 			console.log('请求URL字符串失败！');
// 			errcallback(Util.errorTxt);
// 			dispatch(webViewUrl(''));
// 		};
// 		Util.get(Util.url + '', params, successCallback, errorCallback);
// 	}
// }


// WEBPACK FOOTER //
// ./src/action/webViewContentAction.js